import uniqBy from 'lodash/uniqBy';
import map from 'lodash/map';

export const Helpers = {
getOccupationCode,
getGender,
getState,
accountTypeCode,
getUniquePan,
getMandateStatus,
isCpdForMfuOrBse,
getCartType
}

function getOccupationCode(occupationStr) {
  let occupation = [
    { "code": "02" , "name": "PRIVATE SECTOR SERVICE"},
    {  "code": "02", "name": "PUBLIC SECTOR"},
    {  "code": "01", "name":"BUSINESS"},
    {  "code": "03", "name":"PROFESSIONAL"},
    {  "code": "04", "name":"AGRICULTURIST"},
    {  "code": "05", "name":"RETIRED"},
    {  "code": "06", "name":"HOUSEWIFE"},
    {  "code": "07", "name":"STUDENT"},
    {  "code": "08", "name":"FOREX DEALER"},
    {   "code": "02", "name":"GOVERNMENT SERVICE"},
    {  "code": "02", "name":"PUBLIC SECTOR / GOVERNMENT SERVICE"},
    {  "code": "08", "name":"OTHERS"}
  ];

  for(let elem of occupation) {
    if (elem.name === occupationStr) {
        return elem.code;
    }
  }
}
  
  function getGender(gender) {
    let genderObj = {
      "F" : "Female",
      "M" : "Male"
    }
    return Object.keys(genderObj).find(key => genderObj[key] === gender);
  }
  
  function getState(stateStr) {
    //code:- as per bse 
    //name:- as per bse and kyc data
    var mfuBseStateMap = [
      {
        "code": "AN",
        "name": "Andaman & Nicobar"
      },
      {
        "code" : "AN",
        "name" : "Andaman and Nicobar Islands"
      },
      {
        "code": "AR",
        "name": "Arunachal Pradesh"
      },
      {
        "code": "AP",
        "name": "Andhra Pradesh"
      },
      {
        "code": "AS",
        "name": "Assam"
      },
      {
        "code": "BH",
        "name": "Bihar"
      },
      {
        "code": "CH",
        "name": "Chandigarh"
      },
      {
        "code": "CG",
        "name": "Chhattisgarh"
      },
      {
        "code": "GO",
        "name": "GOA"
      },
      {
        "code" : "GO",
        "name" : "Goa"
      },
      {
        "code": "GU",
        "name": "Gujarat"
      },
      {
        "code": "HA",
        "name": "Haryana"
      },
      {
        "code": "HP",
        "name": "Himachal Pradesh"
      },
      {
        "code": "JM",
        "name": "Jammu & Kashmir"
      },
      {
        "code" : "JM",
        "name" : "Jammu and Kashmir"
      },
      {
        "code": "JK",
        "name": "Jharkhand"
      },
      {
        "code": "KA",
        "name": "Karnataka"
      },
      {
        "code": "KE",
        "name": "Kerala"
      },
      {
        "code": "MP",
        "name": "Madhya Pradesh"
      },
      {
        "code": "MA",
        "name": "Maharashtra"
      },
      {
        "code": "MN",
        "name": "Manipur"
      },
      {
        "code": "ME",
        "name": "Meghalaya"
      },
      {
        "code": "MI",
        "name": "Mizoram"
      },
      {
        "code": "NA",
        "name": "Nagaland"
      },
      {
        "code": "ND",
        "name": "New Delhi"
      },
      {
        "code" : "ND",
        "name" : "Delhi"
      },
      {
        "code": "OR",
        "name": "Orissa"
      },
      {
        "code" : "OR",
        "name" : "Odisha"
      },
      {
        "code": "PO",
        "name": "Pondicherry"
      },
      {
        "code" : "PO",
        "name" : "Puducherry"
      },
      {
        "code": "PU",
        "name": "Punjab"
      },
      {
        "code": "RA",
        "name": "Rajasthan"
      },
      {
        "code": "SI",
        "name": "Sikkim"
      },
      {
        "code": "TG",
        "name": "Telengana"
      },
      {
        "code" : "TG",
        "name" : "Telangana"
      },
      {
        "code": "TN",
        "name": "Tamil Nadu"
      },
      {
        "code": "TR",
        "name": "Tripura"
      },
      {
        "code": "UP",
        "name": "Uttar Pradesh"
      },
      {
        "code": "UC",
        "name": "Uttaranchal"
      },
      {
        "code" : "UC",
        "name" : "Uttarakhand"
      },
      {
        "code": "WB",
        "name": "West Bengal"
      },
      {
        "code": "DN",
        "name": "Dadra and Nagar Haveli"
      },
      {
        "code": "DD",
        "name": "Daman and Diu"
      },
      {
        "code": "LD",
        "name": "Lakshadweep"
      },
      {
        "code": "OH",
        "name": "Others"
      }
    ];
    
    for(let elem of mfuBseStateMap) {
      if (elem.name === stateStr) {
          return elem.code;
      }
    }
    // const INDIAN_STATE_CODES = {
    //   "AN": "Andaman & Nicobar",
    //   "AR": "Arunachal Pradesh",
    //   "AP": "Andhra Pradesh",
    //   "AS": "Assam",
    //   "BH": "Bihar",
    //   "CH": "Chandigarh",
    //   "CG": "Chhattisgarh",
    //   "GO": "GOA",
    //   "GU": "Gujarat",
    //   "HA": "Haryana",
    //   "HP": "Himachal Pradesh",
    //   "JM": "Jammu & Kashmir",
    //   "JK": "Jharkhand",
    //   "KA": "Karnataka",
    //   "KE": "Kerala",
    //   "MP": "Madhya Pradesh",
    //   "MA": "Maharashtra",
    //   "MN": "Manipur",
    //   "ME": "Meghalaya",
    //   "MI": "Mizoram",
    //   "NA": "Nagaland",
    //   "ND": "New Delhi",
    //   "OR": "Orissa",
    //   "PO": "Pondicherry",
    //   "PU": "Punjab",
    //   "RA": "Rajasthan",
    //   "SI": "Sikkim",
    //   "TG": "Telengana",
    //   "TN": "Tamil Nadu",
    //   "TR": "Tripura",
    //   "UP": "Uttar Pradesh",
    //   "UC": "Uttaranchal",
    //   "WB": "West Bengal",
    //   "DN": "Dadra and Nagar Haveli",
    //   "DD": "Daman and Diu",
    //   "LD": "Lakshadweep",
    //   "OH": "Others"
    // };
    //return Object.keys(INDIAN_STATE_CODES).find(key => INDIAN_STATE_CODES[key] === stateStr);
  }

  function accountTypeCode(accountType) {
    let accountTypeList = {
      "SB" : "Saving Bank",
      "CB" : "Current Bank",
      "NE" : "NRE Account",
      "NO" :  "NRO Account"
    }
    return Object.keys(accountTypeList).find(key => accountTypeList[key] === accountType);
  }

  function getUniquePan(data, pending) {

    if (pending && pending.pendingNeeded) {

      var panName = data.map(item => {
        return {"name": item.name, "pan":item.pan, "dob": item.dob}
      });
    } else {
      var panName = data.filter(x => !x.pending).map(item => {
        return {"name": item.name, "pan":item.pan, "dob": item.dob}
      });
    }
    var pan = uniqBy(panName, 'pan');
    return pan.filter(i => Boolean(i.pan));
  }

  function getMandateStatus(code) {
    // code-> whatever bse sends us,
    // value-> what we have to show to user
    // name-> as per values's heading in UI

    let data = [
      {
        "code": "REGISTERED BY MEMBER",
        "value": "Verification Under Process",
        "name": "One Time Mandate Added",
        "iconClass": 2,
        "iconColor": "yellow"
      },

      {
        "code": "WAITING FOR CLIENT AUTHENTICATION",
        "value": "Verification Under Process",
        "name": "One Time Mandate Added",
        "iconClass": 2,
        "iconColor": "yellow"
      },
      {
        "code": "UNDER PROCESSING",
        "value": "Verification Under Process",
        "name": "One Time Mandate Added",
        "iconClass": 2,
        "iconColor": "yellow"
      },
      {
        "code": "INITIAL REJECTION",
        "value": "Verification failed",
        "name": "One Time Mandate Added",
        "iconClass": 3,
        "iconColor": "red"
      },
      {
        "code": "APPROVED",
        "value": "Verified",
        "name": "One Time Mandate Verified",
        "iconClass": 1,
        "iconColor": "#25D782"
      },
    ];

    for(let elem of data) {
      if (elem.code === code) {
          return elem;
      } 
    }
  }

  function isCpdForMfuOrBse(cpd, isBseFlow) { 
      var isAutomatic = cpd && cpd.every(item => item.isAutomatic);
      var isCan =  cpd && cpd.some(item => item.can);
      var isBseFlag = cpd && cpd.some(item => item.isBse);
      var isBseUser = isBseFlow || isBseFlag || (isAutomatic && !isCan)
      var isMfuUser = !isBseUser;
      return {isBseUser, isMfuUser}
  }


  function getCartType(code) {

    if (code === "sip") {
      return "sipcart"
    }
    if (code === "purchase") {
      return "cart"
    }
    else {
      return code
    }
  }